import * as vp from 'vopay';
import moment from 'moment';
import { FunctionComponent, useEffect, useState } from 'react';

import styles from './EditDateDialogue.module.scss';
import { useTranslation } from 'react-i18next';

const { Box, SubTitle, DatepickerSimple, Modal, Button } = vp;

type EditDateDialogueProps = {
  visible: boolean;
  onChange: (e: string) => void;
  initalDate: string;
  onClose: () => void;
};

type FC = FunctionComponent<EditDateDialogueProps>;

const EditDateDialogue: FC = ({ visible, onChange, initalDate, onClose }: EditDateDialogueProps) => {
  const [currentDate, setCurrentDate] = useState(initalDate || '');
  const { t } = useTranslation('translations', { keyPrefix: 'ScheduledTransactions.Details.History.Dialogues' });

  useEffect(() => {
    setCurrentDate(initalDate || '');
  }, [initalDate]);

  return (
    <Modal isVisible={visible} enableBgClick={false}>
      <div className={styles.dialogueMini}>
        <Box flx="col" gapSize="12px">
          <SubTitle subTitle={t('EditScheduledDate.title')} center fontSize="16px" />
          <Box flx="col">
            <Box width="100%" gap="sm">
              <DatepickerSimple
                name="scheduledDate"
                variant="outline"
                isInline
                value={currentDate || ''}
                onBlur={() => {}}
                min={vp.createTimestamp(moment().startOf('day').toDate().getTime())}
                onChange={(event) => {
                  const selectedDate = event.target.value;
                  setCurrentDate(selectedDate);
                }}
              />
            </Box>
          </Box>
          <Box gap="sm" flx="row" jc="center">
            <Button
              id="confirmationDialogue-close"
              color="secondary"
              label={t('EditScheduledDate.cancelButton')}
              width="100%"
              onClick={onClose}
            />
            <Button
              id="save-schedule-date"
              label={t('EditScheduledDate.confirmButton')}
              color="primary"
              onClick={() => {
                onChange(new Date(Number(currentDate)).toLocaleDateString('en-ca'));
              }}
              width="100%"
            />
          </Box>
        </Box>
      </div>
    </Modal>
  );
};

export default EditDateDialogue;
